/* Ergonomie (journal 127, 30/10/2026) : barre d'achat sur téléphone, suggestion dans le tiroir du panier. */
(function () {
  'use strict';

  function texteSansMasque(el) {
    var copie = el.cloneNode(true);
    copie.querySelectorAll('.visually-hidden').forEach(function (n) { n.remove(); });
    return copie.textContent.replace(/\s+/g, ' ').trim();
  }

  /* Palier Xboost : une liste par option et par pièce. Rend le titre de variante choisi pour chaque pièce */
  function piecesDuPalier(palier) {
    var menus = palier ? Array.prototype.slice.call(palier.parentNode.querySelectorAll('select')) : [];
    var quantite = Number(window.xb_qb_current_quantity);
    var parPiece = menus.length / quantite;
    if (!menus.length || !quantite || parPiece % 1) return [];
    var pieces = [];
    for (var i = 0; i < menus.length; i += parPiece) {
      pieces.push(menus.slice(i, i + parPiece).map(function (m) { return m.value; }).join(' / '));
    }
    return pieces;
  }

  /* --- Barre d'achat : visible quand le vrai bouton n'est pas entier à l'écran --- */
  function barreAchat() {
    var barre = document.querySelector('.jl-barre-achat');
    var zone = document.querySelector('.product-block-list__item--info');
    if (!barre || !zone || !('IntersectionObserver' in window)) return;

    var prix = barre.querySelector('.jl-barre-achat__prix');
    var variante = barre.querySelector('.jl-barre-achat__variante');
    var bouton = barre.querySelector('.jl-barre-achat__bouton');
    var cible = null;
    var horsEcran = false;
    var signature = '';
    var allemand = document.documentElement.lang === 'de';

    var observateur = new IntersectionObserver(function (entrees) {
      horsEcran = entrees[entrees.length - 1].intersectionRatio < 0.99;
      afficher();
    }, { threshold: [0, 0.99] });

    function vraiBouton() { return zone.querySelector('.product-form__add-button'); }

    function afficher() {
      var b = vraiBouton();
      var actif = !!b && !b.classList.contains('button--disabled');
      barre.classList.toggle('is-visible', actif && horsEcran);
      document.body.classList.toggle('jl-bouton-visible', actif && !horsEcran);
    }

    /* Palier Xboost choisi : c'est lui qui fixe la quantité ajoutée, donc le prix à afficher */
    function palier() {
      var choix = zone.querySelector('#xb-quantity-breaks-root input[type="radio"]:checked');
      return choix && choix.closest('.xb_quantity_list_item');
    }

    /* Le thème remplace les options à chaque variante : la ligne de pastilles revient sur la pastille choisie */
    var centrees = new WeakSet();
    function recentrer() {
      zone.querySelectorAll('.block-swatch-list').forEach(function (liste) {
        var choix = liste.querySelector('.block-swatch__radio:checked');
        if (!choix || liste.scrollWidth <= liste.clientWidth || centrees.has(liste)) return;
        centrees.add(liste);
        var l = liste.getBoundingClientRect();
        var c = choix.parentNode.getBoundingClientRect();
        liste.scrollLeft += c.left - l.left - (l.width - c.width) / 2;
      });
    }

    /* Le thème remplace ce conteneur à chaque variante : hors de lui, le bloc Xboost survit et suit la variante */
    function abriterPaliers() {
      var racine = document.getElementById('xb-quantity-breaks-root');
      var conteneur = zone.querySelector('.product-form__payment-container');
      if (racine && conteneur && racine.parentNode === conteneur) conteneur.parentNode.insertBefore(racine, conteneur);
      return racine;
    }

    function textePalier(item, classe) {
      var el = item.querySelector(classe);
      return el ? el.textContent.trim() : '';
    }

    /* Téléphone : les paliers deviennent de petits boutons qui cliquent sur ceux du module. Sans bloc lisible, le module reste affiché tel quel */
    function paliersCompacts(racine) {
      var items = racine ? racine.querySelectorAll('.xb_quantity_list_item') : [];
      var liste = zone.querySelector('.jl-paliers');
      var detail = zone.querySelector('.jl-paliers__detail');
      document.body.classList.toggle('jl-paliers-actifs', items.length > 0);
      if (!items.length) {
        if (liste) liste.remove();
        if (detail) detail.remove();
        signature = '';
        return;
      }
      if (!liste) {
        liste = document.createElement('div');
        liste.className = 'jl-paliers';
        liste.setAttribute('role', 'group');
        var titreBloc = racine.querySelector('.xb_quantity_title');
        if (titreBloc) liste.setAttribute('aria-label', titreBloc.textContent.trim());
        racine.parentNode.insertBefore(liste, racine);
        detail = document.createElement('button');
        detail.type = 'button';
        detail.className = 'jl-paliers__detail';
        detail.setAttribute('aria-expanded', 'false');
        detail.addEventListener('click', function () {
          var ouvert = document.body.classList.toggle('jl-paliers-ouverts');
          detail.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
          planifier();
        });
        (racine.parentNode.querySelector('.product-form__payment-container') || racine).after(detail);
      }
      /* Le choix pièce par pièce n'existe que sur les fiches à options : Xboost y ajoute un menu par pièce */
      var texteDetail = document.body.classList.contains('jl-paliers-ouverts') ? (allemand ? 'Details ausblenden' : 'Masquer le détail')
        : racine.querySelector('select') ? (allemand ? 'Einzeln auswählen' : 'Choisir pièce par pièce')
        : (allemand ? 'Details ansehen' : 'Voir le détail');
      if (detail.textContent !== texteDetail) detail.textContent = texteDetail;
      var lignes = Array.prototype.map.call(items, function (item) {
        var sous = textePalier(item, '.xb_quantity_list_item_subtitle');
        var unite = sous.match(/\d+[.,]\d{2}\s*€/);
        return {
          titre: textePalier(item, '.xb_quantity_list_item_title').replace(/\s+(et plus|und mehr)$/i, '+'),
          prix: textePalier(item, '.xb_quantity_list_item_price'),
          sous: unite ? unite[0] + (allemand ? ' / Artikel' : ' / article') : sous,
          choisi: !!item.querySelector('input[type="radio"]:checked')
        };
      });
      var empreinte = JSON.stringify(lignes);
      if (empreinte === signature) return;
      signature = empreinte;
      /* Mêmes boutons si le nombre de paliers ne change pas : le focus clavier reste en place */
      if (liste.children.length === lignes.length) {
        lignes.forEach(function (ligne, rang) {
          var bouton = liste.children[rang];
          bouton.setAttribute('aria-pressed', ligne.choisi ? 'true' : 'false');
          ['titre', 'prix', 'sous'].forEach(function (partie, i) {
            if (bouton.children[i].textContent !== ligne[partie]) bouton.children[i].textContent = ligne[partie];
          });
        });
        return;
      }
      liste.textContent = '';
      lignes.forEach(function (ligne, rang) {
        var bouton = document.createElement('button');
        bouton.type = 'button';
        bouton.className = 'jl-palier';
        bouton.setAttribute('aria-pressed', ligne.choisi ? 'true' : 'false');
        [['titre', ligne.titre], ['prix', ligne.prix], ['sous', ligne.sous]].forEach(function (partie) {
          var span = document.createElement('span');
          span.className = 'jl-palier__' + partie[0];
          span.textContent = partie[1];
          bouton.appendChild(span);
        });
        bouton.addEventListener('click', function () {
          var cible = (document.getElementById('xb-quantity-breaks-root') || racine).querySelectorAll('.xb_quantity_list_item')[rang];
          if (cible) cible.click();
          setTimeout(planifier, 80);
        });
        liste.appendChild(bouton);
      });
    }

    /* Palier « 3 et plus » : le compteur de Xboost revient sur la ligne du bouton, comme la quantité des autres fiches */
    function boutonCompteur(classe) {
      var choisi = palier();
      return choisi ? choisi.parentNode.querySelector('button.' + classe) : null;
    }

    function compteurPalier() {
      var compteur = zone.querySelector('.jl-palier-quantite');
      if (!boutonCompteur('xb-p-1n') || !boutonCompteur('xb-p-1')) {
        if (compteur) compteur.remove();
        return;
      }
      if (!compteur) {
        compteur = document.createElement('div');
        compteur.className = 'jl-palier-quantite quantity-selector quantity-selector--product';
        [['−', 'xb-p-1', allemand ? 'Menge verringern' : 'Diminuer la quantité'], ['', '', ''], ['+', 'xb-p-1n', allemand ? 'Menge erhöhen' : 'Augmenter la quantité']].forEach(function (partie) {
          if (!partie[0]) {
            var valeur = document.createElement('span');
            valeur.className = 'quantity-selector__value';
            valeur.setAttribute('role', 'status');
            compteur.appendChild(valeur);
            return;
          }
          var pas = document.createElement('button');
          pas.type = 'button';
          pas.className = 'quantity-selector__button';
          pas.textContent = partie[0];
          pas.setAttribute('aria-label', partie[2]);
          pas.addEventListener('click', function () {
            var cible = boutonCompteur(partie[1]);
            if (cible) cible.click();
            setTimeout(planifier, 80);
          });
          compteur.appendChild(pas);
        });
        zone.querySelector('.jl-paliers').after(compteur);
      }
      var champ = zone.querySelector('form.product-form [name="quantity"]');
      var nombre = String(window.xb_qb_current_quantity || (champ && champ.value) || '');
      var affiche = compteur.querySelector('.quantity-selector__value');
      if (affiche.textContent !== nombre) affiche.textContent = nombre;
    }

    /* Le bouton annonce le montant du palier choisi. Le CSS l'affiche sur téléphone : le texte du bouton reste à ceux qui le posent (thème, précommande) */
    function annoncerMontant(b, montant) {
      if (!b) return;
      if (montant) b.setAttribute('data-jl-montant', montant);
      else b.removeAttribute('data-jl-montant');
    }

    function synchroniser() {
      var racine = abriterPaliers();
      var b = vraiBouton();
      if (b && b !== cible) {
        if (cible) observateur.unobserve(cible);
        cible = b;
        observateur.observe(b);
      }
      var p = zone.querySelector('.price-list .price:not(.price--compare)');
      if (p) prix.textContent = texteSansMasque(p);
      var valeurs = Array.prototype.map.call(zone.querySelectorAll('.product-form__selected-value'), function (v) {
        return v.textContent.trim();
      });
      var choisi = palier();
      if (choisi) {
        var prixPalier = choisi.querySelector('.xb_quantity_list_item_price');
        var titrePalier = choisi.querySelector('.xb_quantity_list_item_title');
        var pieces = piecesDuPalier(choisi);
        if (prixPalier) prix.textContent = prixPalier.textContent.trim();
        if (pieces.length) valeurs = pieces.some(function (v) { return v !== pieces[0]; }) ? [] : [pieces[0]];
        if (titrePalier) valeurs.unshift(titrePalier.textContent.trim());
      }
      variante.textContent = valeurs.join(' · ');
      paliersCompacts(racine);
      compteurPalier();
      annoncerMontant(b, choisi ? prix.textContent : '');
      recentrer();
      afficher();
    }

    var enAttente = false;
    function planifier() {
      if (enAttente) return;
      enAttente = true;
      var fait = function () {
        if (!enAttente) return;
        enAttente = false;
        synchroniser();
      };
      requestAnimationFrame(fait);
      setTimeout(fait, 100);
    }
    new MutationObserver(planifier).observe(zone, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    zone.addEventListener('change', planifier);

    bouton.addEventListener('click', function () {
      var b = vraiBouton();
      if (b && !b.disabled) b.click();
    });

    synchroniser();
  }

  /* --- Suggestion dans le tiroir : recommandations Shopify, produit absent du panier et avec une seule variante disponible, pour que « + Ajouter » ne choisisse rien à la place du client --- */
  function suggestion() {
    var tiroir = document.getElementById('mini-cart');
    if (!tiroir || !window.fetch) return;
    var enCours = false;

    function presents() {
      return Array.prototype.map.call(tiroir.querySelectorAll('.mini-cart__line-item[data-product-id]'), function (l) {
        return Number(l.getAttribute('data-product-id'));
      });
    }

    function placer() {
      if (enCours || tiroir.querySelector('.jl-suggestion')) return;
      var ids = presents();
      if (!ids.length) return;
      enCours = true;
      fetch('/recommendations/products.json?product_id=' + ids[0] + '&limit=10&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var ids = presents();
          var p = (d.products || []).filter(function (x) {
            return ids.indexOf(x.id) < 0 && x.variants.filter(function (y) { return y.available; }).length === 1;
          })[0];
          var liste = tiroir.querySelector('.mini-cart__line-item-list');
          if (!p || !liste || tiroir.querySelector('.jl-suggestion')) return;
          var v = p.variants.filter(function (x) { return x.available; })[0];
          var bloc = document.createElement('div');
          bloc.className = 'jl-suggestion';
          var titre = document.createElement('p');
          titre.className = 'jl-suggestion__titre';
          titre.textContent = document.documentElement.lang === 'de' ? 'Passt auch dazu' : 'Vous aimerez aussi';
          var infos = document.createElement('div');
          infos.className = 'jl-suggestion__infos';
          var lien = document.createElement('a');
          lien.href = p.url;
          lien.className = 'link';
          lien.textContent = p.title;
          var prix = document.createElement('span');
          prix.className = 'jl-suggestion__prix';
          prix.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(v.price / 100);
          infos.appendChild(lien);
          infos.appendChild(prix);
          var ajout = document.createElement('button');
          ajout.type = 'button';
          ajout.className = 'jl-suggestion__bouton';
          ajout.textContent = document.documentElement.lang === 'de' ? '+ Hinzufügen' : '+ Ajouter';
          ajout.setAttribute('aria-label', (document.documentElement.lang === 'de' ? 'In den Warenkorb: ' : 'Ajouter au panier : ') + p.title);
          ajout.addEventListener('click', function () {
            ajout.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1 })
            }).then(function (r) {
              if (!r.ok) { ajout.disabled = false; return; }
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
            }).catch(function () { ajout.disabled = false; });
          });
          bloc.appendChild(titre);
          if (p.featured_image) {
            var image = document.createElement('img');
            image.className = 'jl-suggestion__image';
            image.src = p.featured_image + (p.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=104';
            image.alt = '';
            image.loading = 'lazy';
            bloc.appendChild(image);
          }
          bloc.appendChild(infos);
          bloc.appendChild(ajout);
          liste.appendChild(bloc);
        })
        .catch(function () {})
        .then(function () { enCours = false; });
    }

    new MutationObserver(function () {
      if (tiroir.getAttribute('aria-hidden') === 'false') placer();
    }).observe(tiroir, { attributes: true, attributeFilter: ['aria-hidden'], subtree: false, childList: true });
    if (tiroir.getAttribute('aria-hidden') === 'false') placer();
  }

  /* --- Vignettes en colonne sur téléphone : le thème ne les fait défiler qu'à l'horizontale --- */
  function vignettes() {
    var liste = document.querySelector('.product-gallery__thumbnail-list');
    if (!liste) return;
    var colonne = liste.parentNode;
    function placer() {
      var v = liste.querySelector('.is-nav-selected');
      if (!v || colonne.scrollHeight <= colonne.clientHeight) return;
      var c = colonne.getBoundingClientRect();
      var t = v.getBoundingClientRect();
      colonne.scrollTop += t.top - c.top - (c.height - t.height) / 2;
    }
    new MutationObserver(placer).observe(liste, { attributes: true, attributeFilter: ['class'], subtree: true });
    placer();
  }

  /* --- Ajout depuis un palier Xboost : les menus du palier font foi. Xboost remet la variante de la page juste avant l'envoi, et le thème transforme ses lignes items[0][id] en un objet que Shopify refuse (400) --- */
  function lignesDuPalier(proprietes) {
    var choix = document.querySelector('#xb-quantity-breaks-root input[type="radio"]:checked');
    var pieces = piecesDuPalier(choix && choix.closest('.xb_quantity_list_item'));
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var variantes = meta && meta.product && meta.product.variants;
    if (!pieces.length || !variantes) return null;
    var comptes = {};
    for (var i = 0; i < pieces.length; i++) {
      var variante = variantes.filter(function (v) { return v.public_title === pieces[i]; })[0];
      if (!variante) return null;
      comptes[variante.id] = (comptes[variante.id] || 0) + 1;
    }
    return Object.keys(comptes).map(function (id) {
      return { id: Number(id), quantity: comptes[id], properties: proprietes };
    });
  }

  function ajoutPalier() {
    var envoyer = window.fetch;
    if (!envoyer) return;
    window.fetch = function (url, options) {
      if (String(url).indexOf('/cart/add') > -1 && options && typeof options.body === 'string') {
        try {
          var corps = JSON.parse(options.body);
          var lignes = corps.properties && corps.properties.__xboost ? lignesDuPalier(corps.properties) : null;
          if (!lignes && corps.id && corps.items && !Array.isArray(corps.items)) {
            lignes = [{ id: corps.id, quantity: corps.quantity, properties: corps.properties }];
            Object.keys(corps.items).forEach(function (cle) {
              if (corps.items[cle].id) lignes.push({ id: corps.items[cle].id, quantity: corps.items[cle].quantity, properties: corps.properties });
            });
          }
          if (lignes) options = Object.assign({}, options, { body: JSON.stringify({ items: lignes }) });
        } catch (e) {}
      }
      return envoyer(url, options);
    };
  }

  function demarrer() { ajoutPalier(); barreAchat(); suggestion(); vignettes(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); } else { demarrer(); }
})();
